// extracted by mini-css-extract-plugin
export default {"content":"ProjectCard_content__hVo5c","skills":"ProjectCard_skills__klTAC","card":"ProjectCard_card__J7LgP","linkCard":"ProjectCard_linkCard__retKY"};